// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/cloud-hazards.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/cloud-hazards/cloud-hazards.js';

mount([g0]);
